<template>
	<div class="service">
		<div class="otitle">
			<div>订单编号: {{mydata.order.trade_no}}</div>
			<div>订单状态: {{mydata.order.order_status_str}}</div>
			<div v-if="again == 0">售后状态: 未申请</div>
			<div v-if="again == 1">售后状态: 再次申请</div>
		</div>
		<div class="table">
			<el-table :data="mydata.order_detail" style="width: 100%" border header-cell-class-name="custom-class">
				<el-table-column prop="product_style_number" label="款号" align="center" header-align="center"
					width="100px">
				</el-table-column>
				<el-table-column prop="product_brand" label="品牌" align="center" header-align="center">
				</el-table-column>
				<el-table-column label="渠道" align="center" header-align="center">
					<template slot-scope="scope">
						{{mydata.shop.shop_name}}
					</template>
				</el-table-column>
				<el-table-column prop="product_size" label="尺码" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="product_season" label="季度" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="product_price" label="单价" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="num" label="下单数量" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="true_num" label="实发数量" align="center" header-align="center">
				</el-table-column>
				<el-table-column label="退货数量" align="center" header-align="center" width="150px">
					<template slot-scope="scope">
						<el-input-number v-model="extra[scope.$index].refund_num" :min="0" :max="scope.row.true_num"
							size="small"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column label="退货原因" align="center" header-align="center" width="170px">
					<template slot-scope="scope">
						<el-select v-model="extra[scope.$index].refund_reason" placeholder="请选择" size="small"
							@change="onselect">
							<el-option v-for="(item,key) in reasonOptions" :label="item.name"
								:value="item.id" :key="key">
							</el-option>
						</el-select>
					</template>
				</el-table-column>
			</el-table>

			<div class="item">
				<!-- 快递面单（单）
				异常问题图片（多）
				质量问题穿着后（多，必填） -->
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
					<el-form-item label="备注">
						<el-input type="textarea" placeholder="" v-model="ruleForm.buyer_apply_remark" :rows="5"
							maxlength="500" show-word-limit>
						</el-input>
					</el-form-item>
					<el-form-item label="是否退款给买家">
						<el-radio-group v-model="ruleForm.is_refund_buyer">
							<el-radio :label="1">已退款</el-radio>
							<el-radio :label="0">未退款</el-radio>
						</el-radio-group>
						<div class="ts">请如实选择，若选择已退款，则平台会提醒渠道不能拒收此单；否则的话，可能会被拒收！</div>
					</el-form-item>
					<el-form-item label="快递面单图片" v-if="picsshow">
						<div class="imgdiv">
							<img class="img" :src="ruleForm.pics1" v-if="ruleForm.pics1">
							<myupload @resultUrl="onimgurl($event,1)" :uptype="1"></myupload>
						</div>
					</el-form-item>
					<el-form-item label="异常问题图片" v-if="picsshow">
						<div class="imgdiv">
							<img class="img" :src="v" v-for="(v,k) in ruleForm.pics2" :key="k">
							<myupload @resultUrl="onimgurl($event,2)" :uptype="3"></myupload>
						</div>
					</el-form-item>
					<el-form-item label="质量问题-穿着后" v-if="picsshow && pics3show" prop="pics3">
						<div class="imgdiv">
							<img class="img" :src="v" v-for="(v,k) in ruleForm.pics3" :key="k">
							<myupload @resultUrl="onimgurl($event,3)" :uptype="3"></myupload>
						</div>
						<div class="ts">沟通补偿订单金额的一半，但买家仍不同意的聊天记录截图</div>
					</el-form-item>
					<el-form-item label="">
						<div class="imgdiv">
							<el-checkbox v-model="ruleForm.buyer_reject_accept" :true-label="1" :false-label="0">
								拒收，原单号退回</el-checkbox>
						</div>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import { isOrderOver90Days, getOrderCreateTime, apiErrorMsg, isServiceStatusAbnormal, supportsFreeReturn } from '@/libraries/utils/afterSale'

	export default {
		name: 'Service',
		data() {
			return {
				mydata: {
					buy_user: {},
					order: {},
					order_detail: [],
					oredr_delivery: [],
					shop: {},
				},

				workload: false,
				extra: [],
				ruleForm: {
					buyer_apply_remark: "",
					buyer_reject_accept: 0,
					is_refund_buyer: 0,
					confirm: 0,
					buyer_apply_pics: "",
					pics1: "",
					pics2: [],
					pics3: []
				},

				rules: {
					pics3: [{
						required: true,
						message: '请上传图片',
						trigger: 'change'
					}]
				},

				picsshow: false,
				pics3show: false,
			}
		},

		mounted() {
			this.oninfo();
		},

		props: {
			checkobj: {
				type: Object,
				default: {}
			},
			
			again: {
				type: Number,
				default: 0
			},
		},

		inject: ['appdata'],

		computed: {
			reasonOptions() {
				var list = (this.appdata.list && this.appdata.list.order_service_reason) || [];
				if (this.mydata.order && Number(this.mydata.order.order_status) === 10) {
					return list.filter(function(item) {
						return Number(item.id) === 3;
					});
				}
				return list;
			}
		},

		methods: {
			oninfo() {
				var tradeNo = this.checkobj.trade_no || (this.checkobj.order && this.checkobj.order.trade_no);
				var obj = {
					trade_no: tradeNo
				}

				this.$axios.post('api/user/order_info', obj).then(res => {
					if (res.data.code == 0) {
						this.mydata = res.data.data;
						this.workload = true;
						this.onextra();
						if (this.again == 1) {
							this.prefillFromLastService();
						}
					} else {
						this.$message.error(apiErrorMsg(res));
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onextra() {
				this.extra = [];
				var defaultReason = (this.mydata.order && Number(this.mydata.order.order_status) === 10) ? 3 : 1;
				this.mydata.order_detail.forEach((v, k) => {
					var obj = {};
					obj.order_detail_id = v.id;
					obj.refund_num = 0;
					obj.refund_reason = defaultReason;
					this.$set(this.extra, k, obj);
				})
			},

			prefillFromLastService() {
				var serviceId = this.checkobj.service && this.checkobj.service.service_id;
				if (!serviceId && this.checkobj.id) {
					serviceId = this.checkobj.id;
				}
				if (!serviceId) {
					return;
				}
				this.$axios.post('api/user/order_service_info', {
					id: serviceId
				}).then(res => {
					if (res.data.code != 0) {
						return;
					}
					var data = res.data.data || {};
					var details = data.order_detail || [];
					var completed = this.mydata.order && Number(this.mydata.order.order_status) === 10;
					details.forEach((v) => {
						var detailId = v.order_detail_id || v.id;
						var idx = -1;
						this.extra.forEach((item, i) => {
							if (item.order_detail_id == detailId) {
								idx = i;
							}
						});
						if (idx < 0) {
							return;
						}
						this.$set(this.extra[idx], 'refund_num', v.refund_num || 0);
						var reason = v.refund_reason;
						if (completed) {
							reason = 3;
						}
						if (reason !== undefined && reason !== null && reason !== '') {
							this.$set(this.extra[idx], 'refund_reason', reason);
						}
					});
					var os = data.order_service || {};
					this.ruleForm.buyer_apply_remark = os.buyer_apply_remark || '';
					this.ruleForm.buyer_reject_accept = os.buyer_reject_accept || 0;
					this.ruleForm.is_refund_buyer = os.is_refund_buyer || 0;
					try {
						var pics = JSON.parse(os.buyer_apply_pics || '{}');
						this.ruleForm.pics1 = pics.kdmd || '';
						this.ruleForm.pics2 = pics.ycwt || [];
						this.ruleForm.pics3 = pics.zlwt || [];
					} catch (e) {}
					this.onselect();
				}).catch(err => {
					console.log(err)
				})
			},

			onselect() {
				var show = false;
				var show3 = false;
				this.extra.forEach((v, k) => {
					if (v.refund_reason != 1 && v.refund_reason != 0) {
						show = true
					}

					if (v.refund_reason == 3) {
						show3 = true;
					}
				})
				this.picsshow = show;
				this.pics3show = show3;
				if (!this.picsshow) {
					this.ruleForm.pics1 = "";
					this.ruleForm.pics2 = [];
					this.ruleForm.pics3 = [];
				}

				if (!this.pics3show) {
					this.ruleForm.pics3 = [];
				}

			},

			validateExtra() {
				if (isOrderOver90Days(getOrderCreateTime(this.mydata.order))) {
					this.$message.warning('订单已超过90天，无法发起售后');
					return false;
				}
				var orderStatus = Number(this.mydata.order && this.mydata.order.order_status);
				var details = this.mydata.order_detail || [];
				var hasChase = false;
				var allChase = true;
				var hasFreeOrChaseReturn = false;
				for (var i = 0; i < this.extra.length; i++) {
					var item = this.extra[i];
					var detail = details[i] || {};
					var refundNum = Number(item.refund_num) || 0;
					var reason = Number(item.refund_reason);
					var trueNum = Number(detail.true_num) || 0;
					if (refundNum > trueNum) {
						this.$message.error('退货数量不能大于实发数量');
						return false;
					}
					if (refundNum > 0 && (!reason || reason === 0)) {
						this.$message.error('退货数量大于0时必须选择退货原因');
						return false;
					}
					if (orderStatus === 10 && reason && reason !== 3) {
						this.$message.error('已成交订单仅支持质量问题-穿着后');
						return false;
					}
					if (reason === 8) {
						hasChase = true;
					} else {
						allChase = false;
					}
					if (refundNum > 0 && (reason === 1 || reason === 8)) {
						hasFreeOrChaseReturn = true;
					}
				}
				if (hasChase) {
					if (!allChase) {
						this.$message.error('含追件时必须所有明细都是追件');
						return false;
					}
					for (var j = 0; j < this.extra.length; j++) {
						var chaseNum = Number(this.extra[j].refund_num) || 0;
						var chaseTrue = Number((details[j] || {}).true_num) || 0;
						if (chaseNum !== chaseTrue) {
							this.$message.error('追件退货数量须等于实发数量');
							return false;
						}
					}
				}
				if (hasFreeOrChaseReturn && orderStatus === 4 && !supportsFreeReturn(this.mydata.shop)) {
					this.$message.error('该订单不支持七天无理由/追件退货');
					return false;
				}
				return true;
			},

			handleApplyError(res) {
				var msg = apiErrorMsg(res);
				this.$message.error(msg);
				if (isServiceStatusAbnormal(msg)) {
					this.$emit('status-abnormal');
				}
			},

			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (!valid) {
						return;
					}
					if (!this.validateExtra()) {
						return;
					}
					var obj = {};
					var that = this;
					obj.trade_no = this.mydata.order.trade_no;
					obj.extra = JSON.stringify(this.extra);
					obj.buyer_apply_remark = this.ruleForm.buyer_apply_remark;
					var pics = {};
					pics.kdmd = this.ruleForm.pics1;
					pics.ycwt = this.ruleForm.pics2;
					pics.zlwt = this.ruleForm.pics3;
					obj.buyer_apply_pics = JSON.stringify(pics);
					obj.buyer_reject_accept = this.ruleForm.buyer_reject_accept;
					obj.is_refund_buyer = this.ruleForm.is_refund_buyer;
					obj.confirm = 0;
					if (this.again == 1) {
						obj.again = 1;
					}
					this.$axios.post('api/user/order_service_apply', obj).then(res => {
						if (res.data.code == 0) {
							this.$confirm(res.data.data.refund_tips_for_buyer)
								.then(_ => {
									obj.confirm = 1;
									this.$axios.post('api/user/order_service_apply', obj).then(res2 => {
										if (res2.data.code == 0) {
											that.$message.success('操作成功');
											that.$emit('subservice', res2.data);
										} else {
											that.handleApplyError(res2);
										}
									}).catch(err => {
										console.log(err)
									})
								}).catch(_ => {});
						} else {
							this.handleApplyError(res);
						}
					}).catch(err => {
						console.log(err)
					})
				})
			},

			onimgurl(url, n) {
				if (n == 1) {
					this.ruleForm.pics1 = url;
				}

				if (n == 2) {
					this.ruleForm.pics2.push(url);
				}

				if (n == 3) {
					this.ruleForm.pics3.push(url);
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.otitle {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px solid #EBEEF5;
		border-bottom: none;

		div {
			width: 33%;
			height: 40px;
			border-right: 1px solid #EBEEF5;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			color: #606266;
		}

		div:nth-child(3) {
			border-right: none;
		}
	}

	.item {
		width: 100%;
		margin-bottom: 10px;
		margin-top: 10px;

		.ohead {
			width: 100%;
			height: 40px;
			font-size: 14px;
			font-weight: bold;
			color: #000;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #EBEEF5;
			margin-bottom: 20px;

			span {
				color: #ff4714;
				margin-left: 6px;
			}
		}
	}

	.el-input-number {
		width: 120px;
	}

	.img {
		width: 178px;
		height: 178px;
		margin-right: 20px;
	}

	.imgdiv {
		display: flex;
	}

	.ts {
		color: #ff4714;
	}
</style>



// WEBPACK FOOTER //
// src/common/service.vue